import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/footer.css';

const MailIcon = () => (
  <svg className="blf-footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3 7l9 6 9-6" />
  </svg>
);

const PhoneIcon = () => (
  <svg className="blf-footer-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M6.5 4h3l1.5 5-2 1.5a11 11 0 005 5l1.5-2 5 1.5v3a2 2 0 01-2 2A15 15 0 014 6.5 2 2 0 016.5 4z" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M14 8h2.5V5H14c-2.2 0-3.5 1.3-3.5 3.6V11H8v3h2.5v8H14v-8h2.4l.4-3H14V8.6C14 8.3 14.2 8 14 8z"
    />
  </svg>
);

const XIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M16.2 4h3.1l-6.8 7.8L20 20h-6.1l-4.8-6.2L3.7 20H.6l7.3-8.4L4 4h6.2l4.3 5.7L16.2 4zm-1.1 14.3h1.7L7.9 5.6H6.1l9 12.7z"
    />
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M8 4h8a4 4 0 014 4v8a4 4 0 01-4 4H8a4 4 0 01-4-4V8a4 4 0 014-4zm0 2a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2V8a2 2 0 00-2-2H8zm9 1.2a1 1 0 110 2 1 1 0 010-2zM12 9a3 3 0 100 6 3 3 0 000-6z"
    />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="currentColor"
      d="M6.5 8.5h3v10h-3v-10zM8 4a1.8 1.8 0 110 3.6A1.8 1.8 0 018 4zm4.5 4.5h2.9v1.4h.1c.4-.8 1.5-1.7 3.1-1.7 3.3 0 3.9 2.2 3.9 5v4.3h-3.1v-3.8c0-.9 0-2.1-1.3-2.1s-1.5 1-1.5 2v3.9h-3.1v-10z"
    />
  </svg>
);

const navLinks = [
  { to: '/', label: 'Inicio' },
  { to: '/about', label: 'Acerca de nosotros' },
  { to: '/volunteer', label: 'Voluntariado' },
  { to: '/se-parte-de-nosotros', label: 'Sé parte de nosotros' },
  { to: '/donations', label: 'Donaciones' },
  { to: '/services', label: 'Servicios' },
  { to: '/subscriptions', label: 'Suscripciones' },
  { to: '/blog', label: 'Blog' },
];

const Footer = () => {
  const year = new Date().getFullYear();

  const handleNewsletterSubmit = (event) => {
    event.preventDefault();
  };

  return (
    <footer className="blf-footer">
      <div className="blf-footer-inner">
        <section className="blf-footer-newsletter">
          <form className="blf-footer-newsletter-form" onSubmit={handleNewsletterSubmit}>
            <label className="blf-footer-email-field">
              <MailIcon />
              <input
                type="email"
                name="email"
                placeholder="Introduzca su dirección de correo"
                className="blf-footer-email-input"
                autoComplete="email"
              />
            </label>
            <button type="submit" className="blf-footer-newsletter-btn">
              Unirse al boletín
            </button>
          </form>

          <div className="blf-footer-newsletter-copy">
            <h2 className="blf-footer-newsletter-title">Únase a nuestro boletín informativo</h2>
            <p className="blf-footer-newsletter-text">
              Regístrate ahora para recibir las últimas actualizaciones sobre promociones y cupones. ¡No te
              preocupes, no enviamos spam!
            </p>
          </div>
        </section>

        <section className="blf-footer-main">
          <div className="blf-footer-help">
            <h3 className="blf-footer-heading">¿Necesitas ayuda?</h3>
            <p className="blf-footer-text">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper
              mattis, pulvinar dapibus leo.
            </p>

            <div className="blf-footer-contact-item">
              <PhoneIcon />
              <div>
                <p className="blf-footer-contact-label">Lunes a viernes: 08 am-9 pm</p>
                <p className="blf-footer-contact-value">0 800 300-353</p>
              </div>
            </div>

            <div className="blf-footer-contact-item">
              <MailIcon />
              <div>
                <p className="blf-footer-contact-label">¿Tienes algún problema?</p>
                <a href="mailto:info@example.com" className="blf-footer-contact-value blf-footer-contact-link">
                  info@example.com
                </a>
              </div>
            </div>
          </div>

          <nav className="blf-footer-nav" aria-label="Navegación del pie de página">
            <h3 className="blf-footer-heading">Navegación</h3>
            <ul className="blf-footer-nav-list">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="blf-footer-nav-link">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <div className="blf-footer-social">
            <h3 className="blf-footer-heading">Siguenos en las redes sociales</h3>
            <div className="blf-footer-social-list">
              <a href="https://facebook.com" className="blf-footer-social-btn" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FacebookIcon />
              </a>
              <a href="https://x.com" className="blf-footer-social-btn" target="_blank" rel="noopener noreferrer" aria-label="X">
                <XIcon />
              </a>
              <a href="https://instagram.com" className="blf-footer-social-btn" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <InstagramIcon />
              </a>
              <a href="https://linkedin.com" className="blf-footer-social-btn" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <LinkedInIcon />
              </a>
            </div>
          </div>
        </section>

        <section className="blf-footer-bottom">
          <div className="blf-footer-bottom-left">
            <p className="blf-footer-donation-text">
              Donaciones a Beyond Limits Foundation © {year}. Todos los derechos reservados.
            </p>
            <div className="blf-footer-payments" aria-label="Métodos de pago">
              <span className="blf-footer-payment blf-footer-payment-visa">VISA</span>
              <span className="blf-footer-payment blf-footer-payment-mastercard" aria-hidden="true">
                <span className="blf-footer-payment-circle blf-footer-payment-circle-red" />
                <span className="blf-footer-payment-circle blf-footer-payment-circle-yellow" />
              </span>
              <span className="blf-footer-payment blf-footer-payment-paypal">PayPal</span>
            </div>
          </div>

          <div className="blf-footer-legal">
            <a href="/terminos" className="blf-footer-legal-link">
              Término y condiciones
            </a>
            <a href="/privacidad" className="blf-footer-legal-link">
              Políticas de Privacidad
            </a>
          </div>
        </section>

        <p className="blf-footer-copyright">© {year} Beyond Limits Foundation. Derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
